import { Injectable, inject } from '@angular/core';
import {
  HttpClient,
  HttpContext,
  HttpEvent,
  HttpHeaders,
  HttpParams,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

type ApiGetOptionsBase = {
  headers?: HttpHeaders | Record<string, string | string[]>;
  context?: HttpContext;
  params?:
    | HttpParams
    | Record<
        string,
        | string
        | number
        | boolean
        | readonly (string | number | boolean)[]
      >;
  reportProgress?: boolean;
  transferCache?: boolean | { includeHeaders?: string[] };
  withCredentials?: boolean;
};

type ApiGetOptions = ApiGetOptionsBase & {
  observe?: 'body' | 'events' | 'response';
  responseType?: 'arraybuffer' | 'blob' | 'json' | 'text';
};

@Injectable({ providedIn: 'root' })
export class Api {

  private http = inject(HttpClient);
  private baseUrl = environment.apiBaseUrl;
  private versions = environment.apiVersions;

  private buildUrl(version: string, endpoint: string): string {
    return `${this.baseUrl}/${version}/${endpoint}`;
  }

  get<T = unknown>(
    version: string,
    endpoint: string,
    options: ApiGetOptions = {},
  ): Observable<T | HttpResponse<T> | HttpEvent<T> | string | Blob | ArrayBuffer> {
    return this.http.get(this.buildUrl(version, endpoint), {
      withCredentials: true,
      ...options,
    } as any);
  }

  post<T>(version: string, endpoint: string, body: any) {
    return this.http.post<T>(
      this.buildUrl(version, endpoint),
      body,
      { withCredentials: true }
    );
  }
private containsFile(obj: any): boolean {

  if (!obj) return false;

  if (obj instanceof File) return true;

  if (Array.isArray(obj)) {
    return obj.some(v => this.containsFile(v));
  }

  if (typeof obj === 'object') {
    return Object.values(obj).some(v => this.containsFile(v));
  }

  return false;
}
//   post<T>(version: string, endpoint: string, body: any) {

//   const hasFile = this.containsFile(body);

//   if (hasFile) {
//     const formData = new FormData();
//     this.buildFormData(formData, body);

//     return this.http.post<T>(
//       this.buildUrl(version, endpoint),
//       formData,
//       { withCredentials: true }
//     );
//   }

//   return this.http.post<T>(
//     this.buildUrl(version, endpoint),
//     body,
//     { withCredentials: true }
//   );
// }
// private buildFormData(formData: FormData, data: any, parentKey?: string) {

//   if (data === null || data === undefined) return;

//   if (data instanceof File) {
//     formData.append(parentKey!, data);
//     return;
//   }

//   if (Array.isArray(data)) {
//     data.forEach((value, index) => {
//       const key = `${parentKey}[${index}]`;
//       this.buildFormData(formData, value, key);
//     });
//     return;
//   }

//   if (typeof data === 'object') {

//     if (parentKey === 'Student') {
//       formData.append(parentKey, JSON.stringify(data));
//       return;
//     }

//     Object.keys(data).forEach(key => {
//       const value = data[key];
//       const formKey = parentKey ? `${parentKey}[${key}]` : key;
//       this.buildFormData(formData, value, formKey);
//     });

//     return;
//   }

//   formData.append(parentKey!, data);
// }
//   postFormData<T>(version: string, endpoint: string, body: any) {

//   const formData = new FormData();

//   this.buildFormData(formData, body);

//   return this.http.post<T>(
//     this.buildUrl(version, endpoint),
//     formData,
//     { withCredentials: true }
//   );

// }

postFormData<T>(version: string, endpoint: string, body: any) {

  const formData = new FormData();

  Object.keys(body).forEach(key => {

    const value = body[key];

    if (value instanceof File) {
      formData.append(key, value);
    } else {
      formData.append(key, value);
    }

  });

  return this.http.post<T>(
    this.buildUrl(version, endpoint),
    formData,
    { withCredentials: true }
  );

}

  put<T>(version: string, endpoint: string, body: any) {
    return this.http.put<T>(
      this.buildUrl(version, endpoint),
      body,
      { withCredentials: true }
    );
  }

  delete<T>(version: string, endpoint: string) {
    return this.http.delete<T>(
      this.buildUrl(version, endpoint),
      { withCredentials: true }
    );
  }
}
